<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} Email Campaign</div>
      <router-link class="btn-blue" :to="{name:'Email Campaigns'}">Email Campaign {{ $tc("list") }}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Campaign Name:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{campaign_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Campaign Type:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selectedCampaignType.campaign_type_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Audience:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selected_segment.segment_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Campaign Start Date:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{campaign_start_date}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Campaign End Date:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{campaign_end_date}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Content Type:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selected_radio}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Email Template:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selected_email_template.et_description}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Email Service Provider:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selected_email_provider.ep_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Email Sender:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selected_email_sender.es_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Delivery Date and Time:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{delivery_datetime}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Delivery Time:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{selected_radio_delivery}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
export default {
  data() {
    return {
      selected_email_template: null,
      campaign_details: "",

      selected_email_provider: {
        ep_id: 0,
        ep_name: ""
      },

      selected_email_sender: {
        es_id: 0,
        es_name: ""
      },

      selected_segment: {
        s_id: 0,
        segment_name: ""
      },
      campaign_name: "",
      campaign_start_date: "",
      campaign_end_date: "",
      email_message: "",

      selected_radio: "",
      delivery_datetime: "",

      selected_radio_delivery: "",

      selectedCampaignType: {
        campaign_type_name: "",
        ct_id: 0
      }
    };
  },
  beforeMount() {
    const { ec_id } = this.$route.params;
    console.log("ec_id :", ec_id);
    if (ec_id) {
      this.getCampaignDetails({ ec_id: ec_id });
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getCampaignDetails(payload) {
      MarketingAutomation.getCampaignDetails({ ec_id: payload.ec_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.campaign_details = data.Records[0];
            console.log("this.campaign_details :", this.campaign_details);
            this.campaign_name = this.campaign_details.campaign_name;
            this.selectedCampaignType.campaign_type_name = this.campaign_details.campaign_type_name;
            this.selectedCampaignType.ct_id = this.campaign_details.ct_id;
            this.selected_segment.segment_name = this.campaign_details.segment_name;
            this.selected_segment.s_id = this.campaign_details.s_id;
            this.campaign_start_date = moment(
              this.campaign_details.campaign_start_date
            ).format("MMMM Do YYYY");
            this.campaign_end_date = moment(
              this.campaign_details.campaign_end_date
            ).format("MMMM Do YYYY");
            this.selected_email_template = {
              et_id: this.campaign_details.et_id,
              et_description: this.campaign_details.et_description
            };
            this.selected_email_provider.ep_id = this.campaign_details.ep_id;
            this.selected_email_provider.ep_name = this.campaign_details.ep_name;
            this.selected_email_sender.es_id = this.campaign_details.es_id;
            this.selected_email_sender.es_name = this.campaign_details.es_name;
            if (this.campaign_details.date_time) {
              this.delivery_datetime = moment
                .unix(this.campaign_details.date_time)
                .format("MMMM Do YYYY,  h:mm:ss a ");
            }
            if (this.campaign_details.is_promotional == "Y") {
              this.selected_radio = "Promotional";
            } else {
              this.selected_radio = "Transactional";
            }

            if (this.campaign_details.is_send_now == "Y") {
              this.selected_radio_delivery = "Now";
            } else {
              this.selected_radio_delivery = "Later";
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/EmailComponents/viewEmailCampaign.vue